module.exports = __webpack_public_path__ + "static/media/logo.cbf109b8.png";